import { useState } from "react";
import { Pressable, type ViewStyle } from "react-native";
import { Text } from "react-native-paper";
import { themeRoundnessMultiplier } from "../../constants";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
export type FollowUpMessageProps = {
	message: string;
	icon?: IconType;
	onPress: () => void;
	type?: "starterMessage" | "default" | "custom";
	style?: ViewStyle;
};
const FollowUpMessage = ({
	message,
	onPress,
	type = "default",
	style,
}: FollowUpMessageProps) => {
	const [opacity, setOpacity] = useState(1);
	const theme = useAppTheme();
	const isCustomMessage = type === "custom";

	if (message === "") {
		return null;
	}

	return (
		<Pressable
			onPress={onPress}
			onPressIn={() => setOpacity(0.5)}
			onPressOut={() => setOpacity(1)}
			style={style}
		>
			{(state) => {
				const hovered = "hovered" in state ? state.hovered : false;
				const getBackgroundColor = () => {
					if (isCustomMessage) {
						return theme.colors.primary;
					}
					return hovered ? theme.colors.inverseOnSurface : "transparent";
				};

				return (
					<Box
						gap={8}
						paddingHorizontal={16}
						backgroundColor={getBackgroundColor()}
						borderWidth={isCustomMessage ? 0 : 1}
						borderColor={theme.colors.outlineVariant}
						paddingVertical={8}
						flexDirection="row"
						alignItems="center"
						style={{
							opacity: opacity,
							borderRadius: theme.roundness * 5,
							borderBottomRightRadius:
								theme.roundness * themeRoundnessMultiplier,
						}}
					>
						{/* {icon && (
							<Icon
								name={icon as IconType}
								size={24}
								color={
									isCustomMessage
										? theme.colors.onPrimary
										: theme.colors.primary
								}
							/>
						)} */}
						<Text
							numberOfLines={0}
							variant="bodyMedium"
							style={{
								color: isCustomMessage
									? theme.colors.onPrimary
									: theme.colors.text,
							}}
						>
							{message}
						</Text>
					</Box>
				);
			}}
		</Pressable>
	);
};

export default FollowUpMessage;
